import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PrimeNgModule } from '../shared/primeng.module';

@Component({
  selector: 'app-landing-page',
  // imports: [CommonModule, PrimeNgModule,],
  standalone:false,
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent implements OnInit , AfterViewInit {
 constructor(private router: Router,) {}

  private chars = "01!@#$%^&*()_+-=[]{}|;:,.<>?/";
  private footerTextElement!: HTMLElement | null;
  private originalText: string = '';

  // ngOnInit(): void {}
  @ViewChild('heroVideo') heroVideoRef!: ElementRef<HTMLVideoElement>;



  ngAfterViewInit(): void {
      const video = this.heroVideoRef?.nativeElement;
  if (video) {
    video.muted = true;
    video.play().catch((err) => {
      console.warn('Autoplay failed:', err);
    });
  }
    this.footerTextElement = document.querySelector('.footer-text');
    if (this.footerTextElement) {
      this.originalText = this.footerTextElement.textContent || '';
    }

    this.revealElements();
    this.checkFooterGlitch();
  }

  // ✅ Scroll event binding
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.revealElements();
    this.checkFooterGlitch();
  }

  // ✅ Element reveal animation
 private revealElements(): void {
    const elements = document.querySelectorAll<HTMLElement>('.reveal');

    elements.forEach((element: HTMLElement) => {
      const windowHeight = window.innerHeight;
      const elementTop = element.getBoundingClientRect().top;
      const elementVisible = 150; // adjust if footer doesn’t trigger

      if (elementTop < windowHeight - elementVisible) {
        element.classList.add('active');
      } else {
        element.classList.remove('active'); // optional, for hide-on-scroll-back
      }
    });
  }

  // ✅ Glitch effect for footer
  private glitchText(): void {
    if (!this.footerTextElement) return;

    let iterations = 0;
    const interval = setInterval(() => {
      if (!this.footerTextElement) return;

      this.footerTextElement.textContent = this.footerTextElement.textContent?.split('')
        .map((letter, index) => {
          if (index < iterations) {
            return this.originalText[index];
          }
          return this.chars[Math.floor(Math.random() * this.chars.length)];
        })
        .join('') || '';

      if (iterations >= this.originalText.length) {
        clearInterval(interval);
        setTimeout(() => {
          if (this.footerTextElement) {
            this.footerTextElement.textContent = this.originalText;
          }
        }, 2000);
      }

      iterations += 1 / 3;
    }, 30);
  }

  // ✅ Check footer visibility
  private checkFooterGlitch(): void {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    const footerTop = footer.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (footerTop < windowHeight) {
      // this.glitchText();
      // only trigger once
      window.removeEventListener('scroll', this.checkFooterGlitch as any);
    }
  }
  navigateToLogin(){
      this.router.navigate(['/login']);
  }
   activeStep = 0;
  isVideoLoaded = false;
  prefersReducedMotion = false;
  private intervalId?: number;

processSteps = [
  {
    id: 'planning',
    title: 'Innovation & Planning',
    description: 'iDEX/TDF/Make initiatives, SQRs & problem statements',
    icon: '💡'  // Lightbulb emoji
  },
  {
    id: 'development',
    title: 'Design & Development',
    description: 'Indigenous prototyping and engineering solutions',
    icon: '🛠️'  // Tools emoji
  },
  {
    id: 'integration',
    title: 'Ship Integration',
    description: 'On-board fitment and system integration',
    icon: '⚙️'  // Gear emoji
  },
  {
    id: 'testing',
    title: 'Trials & Testing',
    description: 'Harbor/sea trials and compliance verification',
    icon: '⏱️'  // Stopwatch emoji
  },
  {
    id: 'production',
    title: 'Mass Production',
    description: 'Scale-up and induction into naval operations',
    icon: '🏭'  // Factory emoji
  },
  {
    id: 'operational',
    title: 'Operational Readiness',
    description: 'Ship sailing with Indian Flag and full capability',
    icon: '🚢'  // Ship emoji
  }
];



  benefits: Benefit[] = [
    {
      title: 'Digitized Approvals',
      description: 'Streamlined routing and automated approval workflows',
      icon: '⚡'
    },
    {
      title: 'Real-time Tracking',
      description: 'Complete visibility of project status and milestones',
      icon: '📊'
    },
    {
      title: 'One-click Approvals',
      description: 'Quick decision-making with modal-based approvals',
      icon: '✅'
    },
    {
      title: 'RBAC & Security',
      description: 'Role-based access control and secure authentication',
      icon: '🔒'
    },
    {
      title: 'Integrated Dashboards',
      description: 'Comprehensive views with comment trails and analytics',
      icon: '📈'
    },
    {
      title: 'Full Audit Logs',
      description: 'Complete traceability and compliance reporting',
      icon: '📋'
    },
    {
      title: 'Faster TAT',
      description: 'Reduced turnaround time for all processes',
      icon: '🚀'
    },
    {
      title: 'Seamless Integration',
      description: 'Easy integration with existing naval systems',
      icon: '🔗'
    }
  ];

  schemes: Scheme[] = [
    {
      name: 'iDEX',
      description: 'Innovation for Defence Excellence',
      details: ['Startup innovation program', 'Technology development support', 'Naval innovation challenges']
    },
    {
      name: 'TDF',
      description: 'Technology Development Fund',
      details: ['R&D funding support', 'Indigenous technology development', 'Industry partnership programs']
    },
    {
      name: 'Make I',
      description: 'Make Category I',
      details: ['Government-funded development', 'Transfer of technology', 'Indigenous manufacturing']
    },
    {
      name: 'Make II',
      description: 'Make Category II',
      details: ['Industry-funded development', 'Private investment model', 'Faster procurement process']
    },
    {
      name: 'Make III',
      description: 'Make Category III',
      details: ['Services-based procurement', 'Outcome-based contracts', 'Performance guarantees']
    },
    {
      name: 'Revenue',
      description: 'Revenue Procurement',
      details: ['Operational equipment procurement', 'Maintenance and support', 'Service contracts']
    },
  ];

  stakeholderGroups = [
    {
      title: 'Innovators & Vendors',
      icon: '🚀',
      points: ['Submit innovative solutions', 'Access funding opportunities', 'Collaborate with Navy teams']
    },
    {
      title: 'Evaluators & Committees',
      icon: '⚖️',
      points: ['Review and assess proposals', 'Technical evaluation', 'Strategic decision making']
    },
    {
      title: 'Navy Program Teams',
      icon: '⚓',
      points: ['Define requirements', 'Oversee implementation', 'Ensure operational readiness']
    }
  ];

  ngOnInit() {
    // Check for reduced motion preference
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.prefersReducedMotion = mediaQuery.matches;
    
    const handleChange = () => this.prefersReducedMotion = mediaQuery.matches;
    mediaQuery.addEventListener('change', handleChange);
    
    // Start timeline animation if motion is not reduced
    if (!this.prefersReducedMotion) {
      this.intervalId = window.setInterval(() => {
        this.activeStep = (this.activeStep + 1) % this.processSteps.length;
      }, 3000);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  onVideoLoaded() {
    this.isVideoLoaded = true;
  }

  scrollToSection(sectionId: string) {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  }

  openSchemeDialog(scheme: Scheme) {
    // Simple alert for now - can be replaced with a proper modal
    alert(`${scheme.name} - ${scheme.description}\n\n${scheme.details.join('\n')}`);
  }

  getProcessIcon(iconId: string): string {
    const icons: { [key: string]: string } = {
      planning: `<svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"/><path d="m9 7 3 3 3-3"/><path d="M12 10V1"/></svg>`,
      development: `<svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="m12 8 4 4-4 4"/></svg>`,
      integration: `<svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27,6.96 12,12.01 20.73,6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
      testing: `<svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4"/><path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/><path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/><path d="M3 12c0 2.2.9 4.2 2.5 5.7"/><path d="M21 12c0 2.2-.9 4.2-2.5 5.7"/></svg>`,
      production: `<svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/><path d="M7 13h10"/><path d="M7 9h4"/></svg>`,
      operational: `<svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11l19-9-9 19-2-8-8-2z"/><path d="M11 13l4-4"/></svg>`
    };
    
    return icons[iconId] || '';
  }
}
interface ProcessStep {
  id: string;
  title: string;
  description: string;
  icon: string;
}

// Benefit interface
interface Benefit {
  title: string;
  description: string;
  icon: string;
}

// Scheme interface
interface Scheme {
  name: string;
  description: string;
  details: string[];
}